var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { alpha, Box, darken, lighten, SvgIcon, Typography } from "@mui/material";
import { forwardRef } from "react";
import { combineSxProps } from "../../Utils";
export const Label = forwardRef(function Label(_a, ref) {
    var { color, startIcon, variant, label, children, size } = _a, restProps = __rest(_a, ["color", "startIcon", "variant", "label", "children", "size"]);
    const sizeSxProps = size === "body"
        ? {
            height: "21px",
            "& svg": { width: "14px", height: "14px" }
        }
        : {
            height: "16px",
            "& svg": { width: "12px", height: "12px" }
        };
    return (_jsxs(Box, Object.assign({}, restProps, { ref: ref, sx: combineSxProps(color === "gradient" && variant === "outlined"
            ? gradientOutlineSxProps
            : containerSxProps(color || "default", variant || "standard"), sizeSxProps), children: [color === "gradient" && variant === "outlined" && startIcon
                ? _jsx(SvgIcon, { color: "gradient", children: startIcon })
                : startIcon, label
                ? _jsx(Typography, { sx: combineSxProps(color === "gradient" && variant === "outlined"
                        ? gradientTextSxProps
                        : undefined, { fontSize: size === "body" ? "14px" : "12px",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis"
                    }), children: label })
                : null] })));
});
const getOutlineStyle = (variant, color, theme) => {
    var _a;
    return variant === "outlined"
        ? color === "default"
            ? `1px solid ${theme.palette.grey[400]}`
            : `1px solid ${alpha((_a = theme.palette[color]) === null || _a === void 0 ? void 0 : _a.main, 0.5)}`
        : "none";
};
const getColor = (color, theme) => {
    var _a;
    return color === "gradient"
        ? theme.palette.common.white
        : color === "default"
            ? darken(theme.palette.text.secondary, 0.6)
            : darken((_a = theme.palette[color]) === null || _a === void 0 ? void 0 : _a.light, 0.6);
};
const getBackgroundColor = (color, variant, theme) => {
    return variant === "standard"
        ? color === "default"
            ? theme.palette.grey[200]
            : lighten(theme.palette[color].light, 0.9)
        : "transparent";
};
const gradientTextSxProps = {
    backgroundImage: theme => `linear-gradient(114deg, ${theme.palette.brand.gradientMagentaBlue})`,
    color: "transparent",
    WebkitBackgroundClip: "text",
    width: "fit-content"
};
const gradientOutlineSxProps = {
    backgroundImage: theme => `linear-gradient(114deg, ${theme.palette.brand.gradientMagentaBlue})`,
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    color: "transparent",
    textAlign: "center",
    display: "flex",
    flexDirection: "row",
    gap: "4px",
    width: "fit-content",
    padding: "0 4px 1px 4px",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "12px",
    position: "relative",
    "&::before": {
        content: "\"\"",
        position: "absolute",
        inset: 0,
        border: "1px solid transparent",
        borderRadius: "4px",
        background: "inherit",
        backgroundOrigin: "border-box",
        backgroundClip: "border-box",
        WebkitMask: "linear-gradient(#fff 0 0) padding-box, linear-gradient(#fff 0 0)",
        WebkitMaskComposite: "xor",
        maskComposite: "exclude",
        WebkitMaskRepeat: "no-repeat"
    }
};
const containerSxProps = (color, variant) => ({
    display: "flex",
    flexDirection: "row",
    backgroundColor: theme => getBackgroundColor(color, variant, theme),
    backgroundImage: theme => color === "gradient" && variant === "standard" ? `linear-gradient(114deg, ${theme.palette.brand.gradientMagentaBlue})` : "none",
    outline: theme => getOutlineStyle(variant, color, theme),
    borderRadius: "4px",
    gap: "4px",
    color: theme => getColor(color, theme),
    width: "fit-content",
    padding: "0 4px 1px 4px",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "12px",
    cursor: "default"
});
//# sourceMappingURL=Label.js.map